const plans = [
  {
    id: 'starter',
    name: 'Starter',
    monthlyPrice: 5,
    priceLabel: '$5/month',
    description:
      'For trying Virgil on a smaller project, with $5 in AI usage included each paid month.',
  },
  {
    id: 'pro',
    name: 'Pro',
    monthlyPrice: 20,
    priceLabel: '$20/month',
    description:
      'For active writers, with $20 in AI usage included each paid month and more room for long-context work.',
    popular: true,
  },
  {
    id: 'studio',
    name: 'Studio',
    monthlyPrice: 50,
    priceLabel: '$50/month',
    description:
      'For heavier individual use and production work, with $50 in AI usage included each paid month.',
  },
];

export function getPlan(planId) {
  return plans.find((plan) => plan.id === planId) || null;
}

export default plans;
